import util from '../util';

export const SOURCE_MAPPINGS = 'SOURCE_MAPPINGS';
export const SOURCE_MAPPING = 'SOURCE_MAPPING';
export const CREATE_SOURCE_MAPPING = 'CREATE_SOURCE_MAPPING';
export const UPDATE_SOURCE_MAPPING = 'UPDATE_SOURCE_MAPPING';
export const RESET_SOURCE_MAPPING = 'RESET_SOURCE_MAPPING';

export const SOURCE_MAPPING_REQUEST = util.requestType(SOURCE_MAPPING);
export const SOURCE_MAPPING_SUCCESS = util.successType(SOURCE_MAPPING);
export const SOURCE_MAPPING_FAILURE = util.failureType(SOURCE_MAPPING);

export const SOURCE_MAPPINGS_REQUEST = util.requestType(SOURCE_MAPPINGS);
export const SOURCE_MAPPINGS_SUCCESS = util.successType(SOURCE_MAPPINGS);
export const SOURCE_MAPPINGS_FAILURE = util.failureType(SOURCE_MAPPINGS);

export const CREATE_SOURCE_MAPPING_REQUEST = util.requestType(
  CREATE_SOURCE_MAPPING,
);
export const CREATE_SOURCE_MAPPING_SUCCESS = util.successType(
  CREATE_SOURCE_MAPPING,
);
export const CREATE_SOURCE_MAPPING_FAILURE = util.failureType(
  CREATE_SOURCE_MAPPING,
);

export const UPDATE_SOURCE_MAPPING_REQUEST = util.requestType(
  UPDATE_SOURCE_MAPPING,
);
export const UPDATE_SOURCE_MAPPING_SUCCESS = util.successType(
  UPDATE_SOURCE_MAPPING,
);
export const UPDATE_SOURCE_MAPPING_FAILURE = util.failureType(
  UPDATE_SOURCE_MAPPING,
);
